import React from 'react';
import Typography from '@material-ui/core/Typography';

import { PageHeaderWrapper } from './PageTemplates';

type PropsType = {
  title: string;
  subtitle?: string;
};

const PageHeader: React.FC<PropsType> = ({ title, subtitle }) => (
  <PageHeaderWrapper>
    <Typography variant="h1">{title}</Typography>
    <Typography variant="subtitle2">{subtitle}</Typography>
  </PageHeaderWrapper>
);

export default PageHeader;
